import type { PlayerVolumeColor } from "app/player/getVolumeIcon"
import type { PlayerControlSize } from "app/player/controlSizes"
import useCanControlVolume from "app/player/hooks/useCanControlVolume"
import PlayerHorizontalVolumeControl from "./PlayerHorizontalVolumeControl"
import PlayerVerticalVolumeControl from "./PlayerVerticalVolumeControl"

type Props = {
  volume: number
  onVolumeChange: (volume: number) => void
  orientation?: "horizontal" | "vertical"
  color?: PlayerVolumeColor
  defaultExpanded?: boolean
  showMuteButton?: boolean
  controlsVisible?: boolean
  controlsHideDelayMs?: number
  size?: PlayerControlSize
}

export default function PlayerVolumeControl({
  orientation = "horizontal",
  volume,
  onVolumeChange,
  color,
  defaultExpanded,
  showMuteButton,
  controlsVisible,
  controlsHideDelayMs,
  size,
}: Props) {
  const canControlVolume = useCanControlVolume()

  if (orientation === "vertical") {
    return (
      <PlayerVerticalVolumeControl
        volume={volume}
        onVolumeChange={onVolumeChange}
        color={color}
        showMuteButton={showMuteButton}
        muteOnly={!canControlVolume}
      />
    )
  }

  return (
    <PlayerHorizontalVolumeControl
      volume={volume}
      onVolumeChange={onVolumeChange}
      color={color}
      defaultExpanded={defaultExpanded}
      controlsVisible={controlsVisible}
      controlsHideDelayMs={controlsHideDelayMs}
      size={size}
      muteOnly={!canControlVolume}
    />
  )
}
